import { Fragment } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { trackRoomModuleClick } from '../../utils/tracking/searchBrowse/nullResultsTracking';

// components
import { SbRespNullSearchResultsHeader } from './SbRespNullSearchResultsHeader';
import { SbRespNullSearchResultsTilesLoader } from './SbRespNullSearchResultsTilesLoader';
import { CategoryRooms } from 'dibs-buyer-layout/exports/CategoryLinks';
import { SbRespFollowSearchBannerLazy } from '../SbRespFollowSearchBanner/SbRespFollowSearchBannerLazy';
import { SbSharedFollowSearchProvider } from '../SbSharedFollowSearchProvider/SbSharedFollowSearchProvider';
import { SbSharedNullSearchRelatedItems } from '../SbSharedNullSearchRelatedItems/SbSharedNullSearchRelatedItems';

// constants
import { VERTICAL_OFFSET_SB_RESP_IMG } from '../../constants/imageConstants';

const onRoomModuleClick = (e, { room }) => trackRoomModuleClick(room.type);

export const SbRespNullSearchResultsComponent = props => {
    const { user, relay, viewer, searchTerm, itemSearch, uriRef, isClient } = props;
    const { isShopByRoomEnabled } = viewer;
    const { environment } = relay;

    return (
        <SbSharedFollowSearchProvider
            user={user}
            uriRef={uriRef}
            searchTerm={searchTerm}
            itemSearch={itemSearch}
            thinTrackingEnabled={false}
        >
            {({
                showFollowButton,
                isFollowing,
                followSearchValue,
                refetchFollow,
                isCategorySearch,
            }) => (
                <Fragment>
                    <SbRespNullSearchResultsHeader
                        itemSearch={itemSearch}
                        searchTerm={searchTerm}
                    />
                    <SbSharedNullSearchRelatedItems
                        user={user}
                        relay={relay}
                        viewer={viewer}
                        isMobile={false}
                        shouldFetchFolder
                        isClient={isClient}
                        lazyLoadStartIndex={4}
                        itemSearch={itemSearch}
                        searchTerm={searchTerm}
                        verticalOffset={VERTICAL_OFFSET_SB_RESP_IMG}
                    />
                    {isClient && (
                        <SbRespFollowSearchBannerLazy
                            user={user}
                            viewer={viewer}
                            buttonSize="large"
                            uriRef={uriRef}
                            isFollowing={isFollowing}
                            refetchFollow={refetchFollow}
                            showFollowButton={showFollowButton}
                            followSearchValue={followSearchValue}
                            isCategorySearch={isCategorySearch}
                            hideStickyBanner
                        />
                    )}
                    <SbRespNullSearchResultsTilesLoader environment={environment} />
                    {isShopByRoomEnabled && <CategoryRooms onClick={onRoomModuleClick} />}
                </Fragment>
            )}
        </SbSharedFollowSearchProvider>
    );
};

SbRespNullSearchResultsComponent.propTypes = {
    user: PropTypes.object,
    uriRef: PropTypes.string,
    viewer: PropTypes.object,
    isClient: PropTypes.bool,
    searchTerm: PropTypes.string,
    relay: PropTypes.object.isRequired,
    itemSearch: PropTypes.object.isRequired,
};

export const SbRespNullSearchResults = createFragmentContainer(SbRespNullSearchResultsComponent, {
    user: graphql`
        fragment SbRespNullSearchResults_user on User {
            ...SbRespFollowSearchBanner_user
            ...SbSharedFollowSearchProvider_user
            ...SbSharedNullSearchRelatedItems_user
        }
    `,
    viewer: graphql`
        fragment SbRespNullSearchResults_viewer on Viewer {
            isShopByRoomEnabled: isEnabledByLocale(featureName: "SHOP_BY_ROOM")
            ...SbRespFollowSearchBanner_viewer
            ...SbSharedNullSearchRelatedItems_viewer
        }
    `,
    itemSearch: graphql`
        fragment SbRespNullSearchResults_itemSearch on ItemSearchQueryConnection {
            ...SbSharedFollowSearchProvider_itemSearch
            ...SbRespNullSearchResultsHeader_itemSearch
            ...SbSharedNullSearchRelatedItems_itemSearch
        }
    `,
});
